// _           __   ___   _____    __   _   _   __   _   _____
// | |        / /  /   | |  _  \  |  \ | | | | |  \ | | /  ___|
// | |  __   / /  / /| | | |_| |  |   \| | | | |   \| | | |
// | | /  | / /  / / | | |  _  /  | |\   | | | | |\   | | |  _
// | |/   |/ /  / /  | | | | \ \  | | \  | | | | | \  | | |_| |
// |___/|___/  /_/   |_| |_|  \_\ |_|  \_| |_| |_|  \_| \_____/

// THIS FILE IS AUTO GENERATED!!!!!!
// DO NO EDIT IT HERE.

// THE TEMPLATE IS AT: tasks/pkg/icon-template/src/index.tsx

import baseIcon, { defaultIconGroupProps } from '@bubble-ui/temp-icon-base';
var IconGiftPath = 'M16 16.5c0 .552-.449 1-1 1h-4v-7h5v6Zm-12 0v-6h5v7H5c-.551 0-1-.448-1-1Zm-1-8h14v-2H3v2Zm16-4h-6.651c.016-.02.037-.033.052-.054l2.135-2.75L12.956.47l-2.135 2.75a.99.99 0 0 1-.782.386h-.007a.993.993 0 0 1-.782-.376L7.112.55 5.548 1.796l2.138 2.681c.007.008.016.014.023.023H1v6h1v6c0 1.654 1.346 3 3 3h10c1.654 0 3-1.346 3-3v-6h1v-6Z';
var IconGift = baseIcon('IconGift', {
  groupProps: defaultIconGroupProps,
  getPath: () => IconGiftPath
});
export default IconGift;
//# sourceMappingURL=index.js.map